import React from "react";
import {Card, CardMedia, Stack, Typography} from "@mui/material";
import {RegistrationApiGet} from "./reg_api";
import {useNavigate} from "react-router-dom";
import userPlaceholder from "../../../assets/imgs/logo.png";
import {ListCardDataCol} from "../../components/styled";
import useDownloadImage from "../storage/useDownloadImage";

type RegListPros = {
    items: RegistrationApiGet[],
}

const RegitrationItem = ({item}: { item: RegistrationApiGet }) => {

    const avatarUrl = useDownloadImage("avatars", item.worker?.avatar_url)
    const navigate = useNavigate()
    const i = item

    return <Card
        key={i.id}
        onClick={() => {
            navigate("/reg/" + i.id)
        }}
        sx={{display: "flex"}}
    >

        <CardMedia
            component="img"
            sx={{width: 100, height: 100, minWidth: 100, objectFit: "cover",}}
            image={avatarUrl || userPlaceholder}
        />
        <ListCardDataCol>
            <Stack sx={{

                margin: 1
            }}>
                <Typography
                    variant={"subtitle1"}> {new Date(i.StartTime).toLocaleString("sl", {
                    month: "numeric",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit"
                })}, {i.profile?.fullName}</Typography>
                <Typography variant={"h4"} color={"text.secondary"}>{i.workTask?.Name}</Typography>
                <Typography variant={"body1"}>{i.worker?.lastName} {i.worker?.firstName}</Typography>

                {i.workOrder && <Typography variant={"body1"} sx={{color: "text.secondary", fontSize: "0.8rem"}}>
                    {i.workOrder.number} {i.workOrder.buyerName}
                </Typography>}
                {i.MachineID &&
                    <Typography variant={"body1"}
                                color={"text.secondary"}>{i.machine?.Code} {i.machine?.Name}</Typography>}
            </Stack>
        </ListCardDataCol>
    </Card>
}

export const searchFields = [
    "worker.firstName",
    "worker.lastName",
    "workTask.Name",
    "workTask.Code",
    "workOrder.productName",
    "workOrder.partnerName",
    "workOrder.number",
    "machine.Code",
    "machine.Name",
]

export default ({items}: RegListPros) => {

    if (items.length == 0) {
        return <Typography variant={"h3"}>Ni odprtih registracij.</Typography>
    }
    return <>
        {items.map(i => <RegitrationItem item={i} key={i.id}/>)}
    </>
}
